// REACT & Libraries
import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../../AbstractElements";
import { PlusSquare } from "react-feather";

// Forms
import CreateNationalityForm from "./CreateNationalityForm";

const CreateNationalityModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn
        color="primary"
        onClick={toggle}
        style={{ display: "flex", alignItems: "center", gap: "2px" }}
      >
        <PlusSquare size={16} />
        Create New Nationality
      </Btn>
      <Modal
        size="md"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Create New Nationality Record</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Add a new nationality option that can be used throughout the HRIS
              for employee and applicant personal information.
            </P>
          </ModalHeader>
          <CreateNationalityForm toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};
export default CreateNationalityModal;
